import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=16211154&scoped=true"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=16211154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16211154",
  null
  
)

export default component.exports